/* eslint-disable no-unused-vars */
import React from 'react';
import styled from 'styled-components';
import { Palette } from 'config';

export const Label = ({ fieldName }) => {
  return (
    <MultiTitle htmlFor={fieldName}>
      <Title>{labelText[fieldName]}</Title>
      {fieldName === '$appnext_postbackparams$' && <SubTitle>(Mandatory)</SubTitle>}
    </MultiTitle>
  );
};

export const MultiTitle = styled.label`
  width: 40%;
  align-self: center;
`;

export const Title = styled.h2`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${Palette.PrimaryGray._700};
`;

export const SubTitle = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: ${Palette.PrimaryGray._500};
  margin-top: 2px;
`;

const labelText = {
  $appnext_postbackparams$: 'Custom Postback Parameters:',
  $appnext_postbackrevenue$: 'Revenue:',
  $appnext_postbackandropackage$: 'App Package / ID:',
  $appnext_deviceid$: 'Device ID:',
  $appnext_userip$: 'User IP:',
  $appnext_placementid$: 'Placement ID:',
  $appnext_eventname$: 'Event Name:',
  $appnext_rejectedreason$: 'Rejected reason:',
};
